import { useState } from 'react';
import useBranch from '../../../../data/branch/useBranch';
import ShallowPanel from '../../../../styled-components/components/Panel/ShallowPanel';
import { getMarketCode } from '../../../../utils/market';
import CreateOemVehicle from './CreateOem';
import CreateOrderVehicle from './CreateOrder';
import CreateRegisteredVehicle from './CreateRegistered';
import { MissingAddress } from './MissingAddress';
import { SelectCreateMethod } from './SelectMethod';
import { type CreateVehiclePanels, getVehiclePanelProps } from './utils';

interface CreateVehiclePanelProps {
  onClose: () => void;
}

const CreateVehiclePanel = ({ onClose }: CreateVehiclePanelProps) => {
  const marketCode = getMarketCode();
  const [activeForm, setActiveForm] = useState<CreateVehiclePanels>(
    marketCode === 'NO' ? 'REGISTERED' : 'SELECT',
  );
  const [showTemplateSelect, setShowTemplateSelect] = useState(false);
  const [branch] = useBranch();
  const missingAddress = !(branch?.longitude && branch?.latitude);

  const { title, onNavBack } = getVehiclePanelProps(
    activeForm,
    setActiveForm,
    showTemplateSelect,
    () => setShowTemplateSelect(false),
    marketCode,
  );

  if (missingAddress) {
    return <MissingAddress onClose={onClose} branch={branch} />;
  }

  return (
    <ShallowPanel title={title} onNavBack={onNavBack} onClose={onClose}>
      {activeForm === 'SELECT' ? <SelectCreateMethod navigatePanel={setActiveForm} /> : null}
      {activeForm === 'REGISTERED' ? (
        <CreateRegisteredVehicle
          onClose={onClose}
          navigatePanel={setActiveForm}
          showTemplateSelect={showTemplateSelect}
          setShowTemplateSelect={setShowTemplateSelect}
          disableVirtual={marketCode === 'NO'}
        />
      ) : null}
      {activeForm === 'OEM' ? (
        <CreateOemVehicle
          onClose={onClose}
          navigatePanel={setActiveForm}
          showTemplateSelect={showTemplateSelect}
          setShowTemplateSelect={setShowTemplateSelect}
        />
      ) : null}
      {activeForm === 'ORDER' ? (
        <CreateOrderVehicle
          onClose={onClose}
          showTemplateSelect={showTemplateSelect}
          setShowTemplateSelect={setShowTemplateSelect}
        />
      ) : null}
    </ShallowPanel>
  );
};

export default CreateVehiclePanel;
